import { useEffect, useRef } from "react";
import { saveStickyFilters } from "../utils/stickyFilterStorage";

/**
 * Persists filter state to sessionStorage whenever it changes.
 * Skips the initial mount so hydration does not overwrite storage.
 *
 * @param {string} screenKey
 * @param {object} filterState
 * @param {(screenKey: string, filterState: object) => void} [persistFn]
 */
export default function usePersistStickyFilters(
  screenKey,
  filterState,
  persistFn = saveStickyFilters
) {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    persistFn(screenKey, filterState);
  }, [screenKey, filterState, persistFn]);
}
